import React, { FC, memo } from 'react'

interface Props {
  onChange(): void
}

const BtnQtyUp: FC<Props> = ({ onChange }) => {
  return (
    <button className="quantity-button / quantity-up" type="button" onClick={onChange}>
      <svg className="sociavore-icon" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" x2="12" y1="8" y2="16"></line>
        <line x1="8" x2="16" y1="12" y2="12"></line>
      </svg>
    </button>
  )
}

export default memo(BtnQtyUp)
